<div id="theClientForm">
    <span *ngIf="title" class="text-lg font-bold">{{ title }}</span>
    <div *ngIf="client" class="pb-0 m-0 overflow-auto">

        <form [formGroup]="clientForm" >

            <!-- First Row -->
            <div class="flex flex-wrap gap-4">
                <mat-form-field appearance="outline" dense class="flex-1 pb-0.5">
                    <mat-label>{{ 'CLIENT.NAME' | translate }}</mat-label>
                    <mat-icon matSuffix class="text-gray-500">storefront</mat-icon>
                    <input name="name" formControlName="name" matInput required>
                </mat-form-field>
                <mat-form-field appearance="outline" dense class="flex-1 pb-0.5">
                    <mat-label>RUT</mat-label>
                    <mat-icon matSuffix class="text-gray-500">fingerprint</mat-icon>
                    <input name="rut" formControlName="rut" matInput>
                </mat-form-field>
            </div>

            <!-- Second Row -->
            <div class="flex flex-wrap gap-4">
                <mat-form-field appearance="outline" dense class="flex-1">
                    <mat-label>Nombre fiscal</mat-label>
                    <mat-icon matSuffix class="text-gray-500">storefront</mat-icon>
                    <input name="fiscalName" formControlName="fiscalName" matInput>
                </mat-form-field>
                <mat-form-field appearance="outline" dense class="flex-1">
                    <mat-label>Teléfono</mat-label>
                    <mat-icon matSuffix class="text-gray-500">phone</mat-icon>
                    <input name="phone" formControlName="phone" matInput>
                </mat-form-field>
            </div>

            <!-- Third Row -->
            <div class="flex flex-wrap gap-4">
                <mat-form-field appearance="outline" dense class="flex-1">
                    <mat-label>Contacto</mat-label>
                    <mat-icon matSuffix class="text-gray-500">person</mat-icon>
                    <input name="contact" formControlName="contact" matInput>
                </mat-form-field>
                <mat-form-field appearance="outline" dense class="flex-1">
                    <mat-label>Correo</mat-label>
                    <mat-icon matSuffix class="text-gray-500">mail</mat-icon>
                    <input name="email" formControlName="email" type="email" matInput>
                </mat-form-field>
            </div>

            <!-- Fourth Row -->
            <div>
                <mat-form-field appearance="outline" dense class="w-full">
                    <mat-label>Otros Contactos</mat-label>
                    <textarea name="otherContacts" formControlName="otherContacts" matInput></textarea>
                </mat-form-field>
            </div>

            <!-- Fifth Row -->
            <div>
                <mat-form-field appearance="outline" dense class="w-full">
                    <mat-label>Dirección</mat-label>
                    <mat-icon matSuffix class="text-gray-500">location_on</mat-icon>
                    <input name="address" formControlName="address" matInput>
                </mat-form-field>
            </div>

            <!-- Sixth Row -->
            <div>
                <mat-form-field appearance="outline" dense class="w-full">
                    <mat-label>{{ 'CLIENT.DESCRIPTION' | translate }}</mat-label>
                    <textarea name="description" formControlName="description" matInput></textarea>
                </mat-form-field>
            </div>

            <!-- Attributes Row -->
            <div class="mr-4 mt-6 bg-white shadow-sm border border-slate-200 rounded-lg w-full"  *ngIf="attributes && attributes.length > 0">
                <div class="mx-3 mb-0 border-slate-200 pt-3 pb-2 px-1">
                    <span class="text-3xl text-slate-600 font-normal">
                        {{'Atributos'}}
                    </span>
                </div>
                <attributes class="p-6" #attributesComp [form]="clientForm" [values]="attributes"></attributes>
            </div>

        </form>

        <!-- Buttons -->
        <div *ngIf="_systemService.canAction('adminClients')" class="flex justify-end gap-4 mt-4">
            <button *ngIf="action !== 'edit'"
                    mat-button mat-raised-button color="warn"
                    (click)="deleteClient()"
                    [disabled]="clientForm.invalid"
                    aria-label="DELETE">
                Borrar
            </button>
            <button *ngIf="action !== 'edit'"
                    mat-button mat-raised-button color="accent"
                    (click)="guardarClient()"
                    [disabled]="clientForm.invalid"
                    aria-label="SAVE">
                Guardar
            </button>
        </div>
    </div>

    <!-- No Client Selected -->
    <div *ngIf="!client">
        <span>Debe seleccionar un cliente para modificar o presionar 'Nuevo' para crear un cliente nuevo</span>
    </div>
</div>
